import { default as React, FunctionComponent } from 'react'
import Splash from '../components/Splash'
import withAccountAndBranch from '../common/withAccountAndBranch'
import PlanEmbed from '../foresight/PlanEmbed'
import { IBranch, IAccount, IUser } from '../types/user'

interface IOwnProps {
  user: IUser
  branch: IBranch
  account?: IAccount
}

const Plan: FunctionComponent<IOwnProps> = ({
  user,
  branch,
  account: currentAccount,
}) => {
  const account = currentAccount || user.account

  if (!branch || !account) return <Splash isLoading />

  return <PlanEmbed accountId={account.id} branchId={branch.id} />
}

export default withAccountAndBranch(Plan)
